// extracted by mini-css-extract-plugin
export default {"container":"DraftsView-module__container--yRF3s","tab":"DraftsView-module__tab--Yq2RF","animatedBackground":"DraftsView-module__animatedBackground--UPgAx"};